import { render, staticRenderFns } from "./WorkflowTable.vue?vue&type=template&id=71616058&scoped=true"
import script from "./WorkflowTable.vue?vue&type=script&lang=js"
export * from "./WorkflowTable.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTable.vue?vue&type=style&index=0&id=71616058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71616058",
  null
  
)

export default component.exports